import React from 'react';
import UpdatePaymentBanDetailsRow from '../UpdatePaymentBanDetailsRow';
import {useSelectedBansForUpdatePayment} from '../../hooks/useSelectedBansForUpdatePayment';

const UpdatePaymentBansDetailsPopup = () => {
  const selectedBans = useSelectedBansForUpdatePayment();

  return (
    <div className='update-payment-bans-details-popup'>
      {selectedBans.map((ban, index) => (
        <React.Fragment key={ban.banNumber}>
          {index > 0 && <div className='update-payment-bans-details-popup__divider' aria-hidden='true' />}
          <UpdatePaymentBanDetailsRow ban={ban} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default UpdatePaymentBansDetailsPopup;
